import type { i18n as I18nInstance } from 'i18next'

export enum LanguageCode {
  English = 'en',
  Dutch = 'nl',
  French = 'fr',
  German = 'de',
}

export type AvailableLanguage = {
  code: LanguageCode
  name: string
}

declare global {
  interface Window {
    i18next: I18nInstance
  }
}
